import { useMutation } from "react-query";
import axios from "axios";
import { MisAPI, StaticTokens } from "../../constants/API";
import {
  MisConfirmRequest,
  MisConfirmResponse,
} from "../../types/Mis/MisTypes";

const resolveTerminalToken = () =>
  typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("token") ||
      StaticTokens.terminalToken
    : StaticTokens.terminalToken;

export const useConfirmMis = () => {
  const token = resolveTerminalToken();
  const {
    mutate: confirmMis,
    mutateAsync: confirmMisAsync,
    isLoading: isConfirming,
    isError: isConfirmError,
    reset,
  } = useMutation(
    ["misConfirm"],
    (payload: MisConfirmRequest) =>
      axios.post<MisConfirmResponse>(MisAPI.confirm, payload, {
        headers: {
          "X-API-TOKEN": token,
        },
      }),
  );

  return { confirmMis, confirmMisAsync, isConfirming, isConfirmError, reset };
};
